import { render, staticRenderFns } from "./ClassPrizeManage.vue?vue&type=template&id=964dee8e&scoped=true"
import script from "./ClassPrizeManage.vue?vue&type=script&lang=js"
export * from "./ClassPrizeManage.vue?vue&type=script&lang=js"
import style0 from "./ClassPrizeManage.vue?vue&type=style&index=0&id=964dee8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964dee8e",
  null
  
)

export default component.exports